import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import "@fortawesome/fontawesome-free/css/all.min.css";
import App from './App';
import * as serviceWorker from './serviceWorker';
import { Snackbar } from 'react-redux-snackbar';
import { Provider } from "react-redux";
import Store from "./redux/Store";

ReactDOM.render( 
    <Provider store={Store}>
        <div>
            <App />
            <Snackbar />
        </div>
    </Provider>
    , document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
